import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, MenuProjectId } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCheckUserMenuAccess, ApiDeleteProject, ApiGetProjectById, ApiInsertProject, ApiUpdateProject, ApiGetContractorDropdown } from "utils/constants/api";
import { GetStatus, money, RoundTwoDecimals } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import ChevronDownIcon from "assets/icon/ChevronDownIcon";
import Dropdown from "components/Input/Dropdown";

export default function ProjectForm(){
    let navigate = useNavigate()
    
    const{ fetch: createProject } = useFetch(ApiInsertProject)
    const{ fetch: updateProject } = useFetch(ApiUpdateProject)
    const{ fetch: getProjectById } = useFetch(ApiGetProjectById)
    const{ fetch: deleteProject } = useFetch(ApiDeleteProject)
    const{ fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)
    const { fetch: getSubConList } = useFetch(ApiGetContractorDropdown)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramProjectId = queryString.get("projectId")

    const [allowDelete, setAllowDelete] = useState(false)
    const [allowUndelete, setAllowUndelete] = useState(false)

    const [clientName, setClientName] = useState(EmptyString)
    const [marketingName, setMarketingName] = useState(EmptyString)
    const [projectLocation, setProjectLocation] = useState(EmptyString)
    const [subConOptions, setSubConOptions] = useState([])
    const [subConName, setSubConName] = useState(EmptyString)
    const [comfee, setComfee] = useState(EmptyString);
    const [termin1, setTermin1] = useState(EmptyString)
    const [termin2, setTermin2] = useState(EmptyString)
    const [termin3, setTermin3] = useState(EmptyString)
    const [termin4, setTermin4] = useState(EmptyString)
    const [termin5, setTermin5] = useState(EmptyString)
    
    const [terminSubCon1, setTerminSubCon1] = useState(EmptyString)
    const [terminSubCon2, setTerminSubCon2] = useState(EmptyString)
    const [terminSubCon3, setTerminSubCon3] = useState(EmptyString)
    const [terminSubCon4, setTerminSubCon4] = useState(EmptyString)
    const [terminSubCon5, setTerminSubCon5] = useState(EmptyString)
    
    const [status, setStatus] = useState(EmptyString)
    const [statusCode, setStatusCode] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [errClientName, setErrClientName] = useState(false)
    const [errMarketingName, setErrMarketingName] = useState(false)
    const [errProjectLocation, setErrProjectLocation] = useState(false)
    const [errSubConName, setErrSubConName] = useState(false)
    const [errComfee, setErrComfee] = useState(false)

    // Furniture
    const [furSalesPrice, setFurSalesPrice] = useState(EmptyString)
    const [furHpp, setFurHpp] = useState(EmptyString)
    const [furOperational, setFurOperational] = useState(EmptyString)
    const [furInsurance, setFurInsurance] = useState(EmptyString)
    const [furMarketingCommission, setFurMarketingCommission] = useState(EmptyString)
    const [furDesigner, setFurDesigner] = useState(EmptyString)
    const [furDrafter, setFurDrafter] = useState(EmptyString)
    const [furTax, setFurTax] = useState(EmptyString)
    const [furProfit, setFurProfit] = useState(EmptyString)
    
    // Civil
    const [civSalesPrice, setCivSalesPrice] = useState(EmptyString)
    const [civHpp, setCivHpp] = useState(EmptyString)
    const [civInsurance, setCivInsurance] = useState(EmptyString)
    const [civMarketingCommission, setCivMarketingCommission] = useState(EmptyString)
    const [civOutMarketing, setCivOutMarketing] = useState(EmptyString)
    const [civInMarketing, setCivInMarketing] = useState(EmptyString)
    const [civDiscount, setCivDiscount] = useState(EmptyString)
    const [civDesigner, setCivDesigner] = useState(EmptyString)
    const [civDrafter, setCivDrafter] = useState(EmptyString)
    const [civTax, setCivTax] = useState(EmptyString)
    const [civProfit, setCivProfit] = useState(EmptyString)

    // Electrical
    const [elSalesPrice, setElSalesPrice] = useState(EmptyString)
    const [elHpp, setElHpp] = useState(EmptyString)
    const [elOutMarketing, setElOutMarketing] = useState(EmptyString)
    const [elInMarketing, setElInMarketing] = useState(EmptyString)
    const [elDiscount, setElDiscount] = useState(EmptyString)
    const [elDesigner, setElDesigner] = useState(EmptyString)
    const [elDrafter, setElDrafter] = useState(EmptyString)
    const [elTax, setElTax] = useState(EmptyString)
    const [elProfit, setElProfit] = useState(EmptyString)

    // Electronic
    const [electronicSalesPrice, setElectronicSalesPrice] = useState(EmptyString)
    const [electronicHpp, setElectronicHpp] = useState(EmptyString)
    const [electronicInMarketing, setElectronicInMarketing] = useState(EmptyString)
    const [electronicDiscount, setElectronicDiscount] = useState(EmptyString)
    const [electronicDesigner, setElectronicDesigner] = useState(EmptyString)
    const [electronicOthers, setElectronicOthers] = useState(EmptyString)
    const [electronicProfit, setElectronicProfit] = useState(EmptyString)

    // Accesscories
    const [accSalesPrice, setAccSalesPrice] = useState(EmptyString)
    const [accHpp, setAccHpp] = useState(EmptyString)
    const [accOutMarketing, setAccOutMarketing] = useState(EmptyString)
    const [accInMarketing, setAccInMarketing] = useState(EmptyString)
    const [accDiscount, setAccDiscount] = useState(EmptyString)
    const [accDesigner, setAccDesigner] = useState(EmptyString)
    const [accDrafter, setAccDrafter] = useState(EmptyString)
    const [accOthers, setAccOthers] = useState(EmptyString)
    const [accProfit, setAccProfit] = useState(EmptyString)

    // Summary
    const [totalGrossProfit, setTotalGrossProfit] = useState(EmptyString)

    const [showFurniture, setShowFurniture] = useState(true)
    const [showCivil, setShowCivil] = useState(true)
    const [showElectrical, setShowElectrical] = useState(true)
    const [showElectronic, setShowElectronic] = useState(true)
    const [showAccessories, setShowAccessories] = useState(true)

    const clientNameChange = (e) => {
        setClientName(e.target.value)
    }
    const marketingNameChange = (e) => {
        setMarketingName(e.target.value)
    }
    const projectLocationChange = (e) => {
        setProjectLocation(e.target.value)
    }
    const subConNameChange = (e) => {
        setSubConName(e.value)
    }
    const comfeeChange = (e) => {
        setComfee(money(e.target.value))
    }
    const termin1Change = (e) => {
        setTermin1(money(e.target.value))
    }
    const termin2Change = (e) => {
        setTermin2(money(e.target.value))
    }
    const termin3Change = (e) => {
        setTermin3(money(e.target.value))
    }
    const termin4Change = (e) => {
        setTermin4(money(e.target.value))
    }
    const termin5Change = (e) => {
        setTermin5(money(e.target.value))
    }

    const terminSubCon1Change = (e) => {
        setTerminSubCon1(money(e.target.value))
    }
    const terminSubCon2Change = (e) => {
        setTerminSubCon2(money(e.target.value))
    }
    const terminSubCon3Change = (e) => {
        setTerminSubCon3(money(e.target.value))
    }
    const terminSubCon4Change = (e) => {
        setTerminSubCon4(money(e.target.value))
    }
    const terminSubCon5Change = (e) => {
        setTerminSubCon5(money(e.target.value))
    }

    // Furniture Change Event
    const furSalesPriceChange = (e) => {
        setFurSalesPrice(money(e.target.value))
    }
    const furHppChange = (e) => {
        setFurHpp(money(e.target.value))
    }
    const furOperationalChange = (e) => {
        setFurOperational(money(e.target.value))
    }
    const furInsuranceChange = (e) => {
        setFurInsurance(money(e.target.value))
    }
    const furMarketingCommissionChange = (e) => {
        setFurMarketingCommission(money(e.target.value))
    }
    const furDesignerChange = (e) => {
        setFurDesigner(money(e.target.value))
    }
    const furDrafterChange = (e) => {
        setFurDrafter(money(e.target.value))
    }
    const furTaxChange = (e) => {
        setFurTax(money(e.target.value))
    }
    const furProfitChange = (e) => {
        setFurProfit(money(e.target.value))
    }

    // Civil Change Event
    const civSalesPriceChange = (e) => {
        setCivSalesPrice(money(e.target.value))
    }
    const civHppChange = (e) => {
        setCivHpp(money(e.target.value))
    }
    const civInsuranceChange = (e) => {
        setCivInsurance(money(e.target.value))
    }
    const civMarketingCommissionChange = (e) => {
        setCivMarketingCommission(money(e.target.value))
    }
    const civOutMarketingChange = (e) => {
        setCivOutMarketing(money(e.target.value))
    }
    const civInMarketingChange = (e) => {
        setCivInMarketing(money(e.target.value))
    }
    const civDiscountChange = (e) => {
        setCivDiscount(money(e.target.value))
    }
    const civDesignerChange = (e) => {
        setCivDesigner(money(e.target.value))
    }
    const civDrafterChange = (e) => {
        setCivDrafter(money(e.target.value))
    }
    const civTaxChange = (e) => {
        setCivTax(money(e.target.value))
    }
    const civProfitChange = (e) => {
        setCivProfit(money(e.target.value))
    }

    // Electric Change Event
    const elSalesPriceChange = (e) => {
        setElSalesPrice(money(e.target.value))
    }
    const elHppChange = (e) => {
        setElHpp(money(e.target.value))
    }
    const elOutMarketingChange = (e) => {
        setElOutMarketing(money(e.target.value))
    }
    const elInMarketingChange = (e) => {
        setElInMarketing(money(e.target.value))
    }
    const elDiscountChange = (e) => {
        setElDiscount(money(e.target.value))
    }
    const elDesignerChange = (e) => {
        setElDesigner(money(e.target.value))
    }
    const elDrafterChange = (e) => {
        setElDrafter(money(e.target.value))
    }
    const elTaxChange = (e) => {
        setElTax(money(e.target.value))
    }
    const elProfitChange = (e) => {
        setElProfit(money(e.target.value))
    }

    // Electronics Change Event
    const electronicSalesPriceChange = (e) => {
        setElectronicSalesPrice(money(e.target.value))
    }
    const electronicHppChange = (e) => {
        setElectronicHpp(money(e.target.value))
    }
    const electronicInMarketingChange = (e) => {
        setElectronicInMarketing(money(e.target.value))
    }
    const electronicDiscountChange = (e) => {
        setElectronicDiscount(money(e.target.value))
    }
    const electronicDesignerChange = (e) => {
        setElectronicDesigner(money(e.target.value))
    }
    const electronicOthersChange = (e) => {
        setElectronicOthers(money(e.target.value))
    }
    const electronicProfitChange = (e) => {
        setElectronicProfit(money(e.target.value))
    }

    // Accessories Change Event
    const accSalesPriceChange = (e) => {
        setAccSalesPrice(money(e.target.value))
    }
    const accHppChange = (e) => {
        setAccHpp(money(e.target.value))
    }
    const accOutMarketingChange = (e) => {
        setAccOutMarketing(money(e.target.value))
    }
    const accInMarketingChange = (e) => {
        setAccInMarketing(money(e.target.value))
    }
    const accDiscountChange = (e) => {
        setAccDiscount(money(e.target.value))
    }
    const accDesignerChange = (e) => {
        setAccDesigner(money(e.target.value))
    }
    const accDrafterChange = (e) => {
        setAccDrafter(money(e.target.value))
    }
    const accOthersChange = (e) => {
        setAccOthers(money(e.target.value))
    }
    const accProfitChange = (e) => {
        setAccProfit(money(e.target.value))
    }

    const totalGrossProfitChange = (e) => {
        setTotalGrossProfit(e.target.value)
    }

    const furnitureClick = () => {
        setShowFurniture(!showFurniture)
    }
    const civilClick = () => {
        setShowCivil(!showCivil)
    }
    const electricalClick = () => {
        setShowElectrical(!showElectrical)
    }
    const electronicClick = () => {
        setShowElectronic(!showElectronic)
    }
    const accessoriesClick = () => {
        setShowAccessories(!showAccessories)
    }

    const calculateTotalSales = () => {
        let furniture = furSalesPrice === EmptyString ? 0 : parseInt(furSalesPrice.replaceAll(",", ""))
        let civil = civSalesPrice === EmptyString ? 0 : parseInt(civSalesPrice.replaceAll(",", ""))
        let electrical = elSalesPrice === EmptyString ? 0 : parseInt(elSalesPrice.replaceAll(",", ""))
        let electronics = electronicSalesPrice === EmptyString ? 0 : parseInt(electronicSalesPrice.replaceAll(",", ""))
        let accessories = accSalesPrice === EmptyString ? 0 : parseInt(accSalesPrice.replaceAll(",", ""))
        
        let totalSales = furniture + civil + electrical + electronics + accessories

        return totalSales
    }

    const calculateTotalProfit = () => {
        let furniture = furProfit === EmptyString ? 0 : parseInt(furProfit.replaceAll(",", ""))
        let civil = civProfit === EmptyString ? 0 : parseInt(civProfit.replaceAll(",", ""))
        let electrical = elProfit === EmptyString ? 0 : parseInt(elProfit.replaceAll(",", ""))
        let electronics = electronicProfit === EmptyString ? 0 : parseInt(electronicProfit.replaceAll(",", ""))
        let accessories = accProfit === EmptyString ? 0 : parseInt(accProfit.replaceAll(",", ""))
        
        let totalProfit = furniture + civil + electrical + electronics + accessories

        return totalProfit
    }
    const calculateMargin = () => {
        let profit = calculateTotalProfit()
        let sales = calculateTotalSales()

        let margin = profit / sales * 100

        if (isNaN(margin)){
            return 0
        }else{
            return margin
        }
    }
    const calculateMarginFurniture = () => {
        let salesPrice = furSalesPrice === EmptyString ? 0 : parseFloat(furSalesPrice.replaceAll(",", ""))
        let profit = furProfit === EmptyString ? 0 : parseFloat(furProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100

        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    const calculateMarginCivil = () => {
        let salesPrice = civSalesPrice === EmptyString ? 0 : parseFloat(civSalesPrice.replaceAll(",", ""))
        let profit = civProfit === EmptyString ? 0 : parseFloat(civProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100
        
        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    const calculateMarginElectronics = () => {
        let salesPrice = electronicSalesPrice === EmptyString ? 0 : parseFloat(electronicSalesPrice.replaceAll(",", ""))
        let profit = electronicProfit === EmptyString ? 0 : parseFloat(electronicProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100
        
        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    const calculateMarginAccessories = () => {
        let salesPrice = accSalesPrice === EmptyString ? 0 : parseFloat(accSalesPrice.replaceAll(",", ""))
        let profit = accProfit === EmptyString ? 0 : parseFloat(accProfit.replaceAll(",", ""))

        let margin = profit / salesPrice * 100
        
        if (isNaN(margin)){
            margin = 0
        }

        return margin
    }
    const calculateFurnitureProfit = () => {
        let furnitureSalesPrice = furSalesPrice === EmptyString ? 0 : parseInt(furSalesPrice.replaceAll(",", ""))

        let hpp = furHpp === EmptyString ? 0 : parseInt(furHpp.replaceAll(",", ""))
        let operational = furOperational === EmptyString ? 0 : parseInt(furOperational.replaceAll(",", ""))
        let insurance = furInsurance === EmptyString ? 0 : parseInt(furInsurance.replaceAll(",", ""))
        let commission = furMarketingCommission === EmptyString ? 0 : parseInt(furMarketingCommission.replaceAll(",", ""))
        let designer = furDesigner === EmptyString ? 0 : parseInt(furDesigner.replaceAll(",", ""))
        let drafter = furDrafter === EmptyString ? 0 : parseInt(furDrafter.replaceAll(",", ""))
        let tax = furTax === EmptyString ? 0 : parseInt(furTax.replaceAll(",", ""))
        
        let totalExp = hpp + operational + insurance + commission + designer + drafter + tax

        if (furnitureSalesPrice < totalExp){
            setFurProfit("0")
        }else{
            let profit = furnitureSalesPrice - totalExp
            setFurProfit(money(String(profit)))
        }
    }
    const calculateCivilProfit = () => {
        let civilSalesPrice = civSalesPrice === EmptyString ? 0 : parseInt(civSalesPrice.replaceAll(",", ""))

        let hpp = civHpp === EmptyString ? 0 : parseInt(civHpp.replaceAll(",", ""))
        let insideMarketing = civInMarketing === EmptyString ? 0 : parseInt(civInMarketing.replaceAll(",", ""))
        let outsideMarketing = civOutMarketing === EmptyString ? 0 : parseInt(civOutMarketing.replaceAll(",", ""))
        let discount = civDiscount === EmptyString ? 0 : parseInt(civDiscount.replaceAll(",", ""))
        let insurance = civInsurance === EmptyString ? 0 : parseInt(civInsurance.replaceAll(",", ""))
        let marketingCommission = civMarketingCommission === EmptyString ? 0 : parseInt(civMarketingCommission.replaceAll(",", ""))
        let designer = civDesigner === EmptyString ? 0 : parseInt(civDesigner.replaceAll(",", ""))
        let drafter = civDrafter === EmptyString ? 0 : parseInt(civDrafter.replaceAll(",", ""))
        let tax = civTax === EmptyString ? 0 : parseInt(civTax.replaceAll(",", ""))
        
        let totalExp = hpp + insideMarketing + outsideMarketing + discount + designer + drafter + tax + insurance + marketingCommission

        if (civilSalesPrice < totalExp){
            setCivProfit("0")
        }else{
            let profit = civilSalesPrice - totalExp
            setCivProfit(money(String(profit)))
        }
    }
    const calculateElectricalProfit = () => {
        let electricalSalesPrice = elSalesPrice === EmptyString ? 0 : parseInt(elSalesPrice.replaceAll(",", ""))

        let hpp = elHpp === EmptyString ? 0 : parseInt(elHpp.replaceAll(",", ""))
        let insideMarketing = elInMarketing === EmptyString ? 0 : parseInt(elInMarketing.replaceAll(",", ""))
        let outsideMarketing = elOutMarketing === EmptyString ? 0 : parseInt(elOutMarketing.replaceAll(",", ""))
        let discount = elDiscount === EmptyString ? 0 : parseInt(elDiscount.replaceAll(",", ""))
        let designer = elDesigner === EmptyString ? 0 : parseInt(elDesigner.replaceAll(",", ""))
        let drafter = elDrafter === EmptyString ? 0 : parseInt(elDrafter.replaceAll(",", ""))
        let tax = elTax === EmptyString ? 0 : parseInt(elTax.replaceAll(",", ""))
        
        let totalExp = hpp + insideMarketing + outsideMarketing + discount + designer + drafter + tax

        if (electricalSalesPrice < totalExp){
            setElProfit("0")
        }else{
            let profit = electricalSalesPrice - totalExp
            setElProfit(money(String(profit)))
        }
    }
    const calculateElectronicProfit = () => {
        let electronicSales = electronicSalesPrice === EmptyString ? 0 : parseInt(electronicSalesPrice.replaceAll(",", ""))

        let hpp = electronicHpp === EmptyString ? 0 : parseInt(electronicHpp.replaceAll(",", ""))
        let insideMarketing = electronicInMarketing === EmptyString ? 0 : parseInt(electronicInMarketing.replaceAll(",", ""))
        let discount = electronicDiscount === EmptyString ? 0 : parseInt(electronicDiscount.replaceAll(",", ""))
        let designer = electronicDesigner === EmptyString ? 0 : parseInt(electronicDesigner.replaceAll(",", ""))
        let others = electronicOthers === EmptyString ? 0 : parseInt(electronicOthers.replaceAll(",", ""))
        
        let totalExp = hpp + insideMarketing + discount + designer + others

        if (electronicSales < totalExp){
            setElectronicProfit("0")
        }else{
            let profit = electronicSales - totalExp
            setElectronicProfit(money(String(profit)))
        }
    }
    const calculateAccessoriesProfit = () => {
        let accessoriesSales = accSalesPrice === EmptyString ? 0 : parseInt(accSalesPrice.replaceAll(",", ""))

        let hpp = accHpp === EmptyString ? 0 : parseInt(accHpp.replaceAll(",", ""))
        let outsideMarketing = accOutMarketing === EmptyString ? 0 : parseInt(accOutMarketing.replaceAll(",", ""))
        let insideMarketing = accInMarketing === EmptyString ? 0 : parseInt(accInMarketing.replaceAll(",", ""))
        let discount = accDiscount === EmptyString ? 0 : parseInt(accDiscount.replaceAll(",", ""))
        let designer = accDesigner === EmptyString ? 0 : parseInt(accDesigner.replaceAll(",", ""))
        let drafter = accDrafter === EmptyString ? 0 : parseInt(accDrafter.replaceAll(",", ""))
        let others = accOthers === EmptyString ? 0 : parseInt(accOthers.replaceAll(",", ""))
        
        let totalExp = hpp + insideMarketing + outsideMarketing + discount + designer + others + drafter

        if (accessoriesSales < totalExp){
            setAccProfit("0")
        }else{
            let profit = accessoriesSales - totalExp
            setAccProfit(money(String(profit)))
        }
    }
    const checkTotalTermin = () => {
        let comfeeFee = comfee === EmptyString ? 0 : parseFloat(comfee.replaceAll(",", ""))
        let t1 = termin1 === EmptyString ? 0 : parseFloat(termin1.replaceAll(",", ""))
        let t2 = termin2 === EmptyString ? 0 : parseFloat(termin2.replaceAll(",", ""))
        let t3 = termin3 === EmptyString ? 0 : parseFloat(termin3.replaceAll(",", ""))
        let t4 = termin4 === EmptyString ? 0 : parseFloat(termin4.replaceAll(",", ""))
        let t5 = termin5 === EmptyString ? 0 : parseFloat(termin5.replaceAll(",", ""))

        let ts1 = terminSubCon1 === EmptyString ? 0 : parseFloat(terminSubCon1.replaceAll(",", ""))
        let ts2 = terminSubCon2 === EmptyString ? 0 : parseFloat(terminSubCon2.replaceAll(",", ""))
        let ts3 = terminSubCon3 === EmptyString ? 0 : parseFloat(terminSubCon3.replaceAll(",", ""))
        let ts4 = terminSubCon4 === EmptyString ? 0 : parseFloat(terminSubCon4.replaceAll(",", ""))
        let ts5 = terminSubCon5 === EmptyString ? 0 : parseFloat(terminSubCon5.replaceAll(",", ""))
        
        let totalTermin = t1 + t2 + t3 + t4 + t5 + comfeeFee
        let totalTerminSubCon = ts1 + ts2 + ts3 + ts4 + ts5
        setFurSalesPrice(money(totalTermin))
        setFurHpp(money(totalTerminSubCon))
    }
    
    const [errNpwp, setErrNpwp] = useState(false)
    const [errTermin, setErrTermin] = useState(false)
    const [errTerminMessage, setErrTerminMessage] = useState(EmptyString)
    const [errTerminSubCon, setErrTerminSubCon] = useState(false)
    const [errTerminSubConMessage, setErrTerminSubConMessage] = useState(EmptyString)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Button
    const saveBtnClick = () => {
        if (fFormValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})
    
                if(formType === FormTypeAdd){
                    fCreateProject().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateProject(paramProjectId).then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            let stat

            if (statusCode === 1){
                stat = "2"
            }else{
                stat = "1"
            }

            fDeleteProject(paramProjectId, stat).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    async function fGetSubConList(){
        await getSubConList({
            data: {
                // companyId: localStorage.getItem("CompanyId")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){

                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].contractorName, value: String(response.data[i].contractorId) })
                }

                setSubConOptions(tempArray)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    useEffect(() => {
        if(formType === FormTypeEdit){
            setLoading({isOpen: true})
        }
        
        fCheckUserAccess(localStorage.getItem("Id"), MenuProjectId, localStorage.getItem("CompanyId")).then((res) => {
            if(!res.access){
                navigate("/access-denied")
            }
            if(formType === FormTypeEdit){
                if(res.edit){
                    setLoading({isOpen: true})
                
                    fGetProjectById(paramProjectId).then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    navigate("/access-denied")
                }
            }else{
                fGetSubConList().then(() => {
                    setLoading({isOpen: false})
                })
                // if(res.create){
                //     setTermin1("30")
                //     setTermin2("20")
                //     setTermin3("20")
                //     setTermin4("20")
                //     setTermin5("10")
                //     setTerminSubCon1("30")
                //     setTerminSubCon2("20")
                //     setTerminSubCon3("20")
                //     setTerminSubCon4("20")
                //     setTerminSubCon5("10")
                // }
            }
            
            if(res.delete){
                setAllowDelete(true)
            }
            if(res.unDelete){
                setAllowUndelete(true)
            }
        })        
        
    }, [])

    // Function Api Call
    async function fCreateProject(){
        let projectFurniture = {
            furnitureSellingPrice: furSalesPrice === EmptyString ? 0 : parseFloat(furSalesPrice.replaceAll(",", "")),
            hppDhowi: furHpp === EmptyString ? 0 : parseFloat(furHpp.replaceAll(",", "")),
            workerOperational: furOperational === EmptyString ? 0 : parseFloat(furOperational.replaceAll(",", "")),
            insurance: furInsurance === EmptyString ? 0 : parseFloat(furInsurance.replaceAll(",", "")),
            marketingCommission: furMarketingCommission === EmptyString ? 0 : parseFloat(furMarketingCommission.replaceAll(",", "")),
            designer: furDesigner === EmptyString ? 0 : parseFloat(furDesigner.replaceAll(",", "")),
            drafter: furDrafter === EmptyString ? 0 : parseFloat(furDrafter.replaceAll(",", "")),
            tax: furTax === EmptyString ? 0 : parseFloat(furTax.replaceAll(",", "")),
            profit: furProfit === EmptyString ? 0 : parseFloat(furProfit.replaceAll(",", ""))
        }
        let projectSipil = {
            civilSellingPrice: civSalesPrice === EmptyString ? 0 : parseFloat(civSalesPrice.replaceAll(",", "")),
            hppDhowi: civHpp === EmptyString ? 0 : parseFloat(civHpp.replaceAll(",", "")),
            externalMarketing: civOutMarketing === EmptyString ? 0 : parseFloat(civOutMarketing.replaceAll(",", "")),
            internalMarketing: civInMarketing === EmptyString ? 0 : parseFloat(civInMarketing.replaceAll(",", "")),
            discount: civDiscount === EmptyString ? 0 : parseFloat(civDiscount.replaceAll(",", "")),
            insurance: civInsurance === EmptyString ? 0 : parseFloat(civInsurance.replaceAll(",", "")),
            marketingCommission: civMarketingCommission === EmptyString ? 0 : parseFloat(civMarketingCommission.replaceAll(",", "")),
            designer: civDesigner === EmptyString ? 0 : parseFloat(civDesigner.replaceAll(",", "")),
            drafter: civDrafter === EmptyString ? 0 : parseFloat(civDrafter.replaceAll(",", "")),
            tax: civTax === EmptyString ? 0 : parseFloat(civTax.replaceAll(",", "")),
            profit: civProfit === EmptyString ? 0 : parseFloat(civProfit.replaceAll(",", ""))
        }
        let projectElectrical = {
            electricalSellingPrice: elSalesPrice === EmptyString ? 0 : parseFloat(elSalesPrice.replaceAll(",", "")),
            hppDhowi: elHpp === EmptyString ? 0 : parseFloat(elHpp.replaceAll(",", "")),
            externalMarketing: elOutMarketing === EmptyString ? 0 : parseFloat(elOutMarketing.replaceAll(",", "")),
            internalMarketing: elInMarketing === EmptyString ? 0 : parseFloat(elInMarketing.replaceAll(",", "")),
            discount: elDiscount === EmptyString ? 0 : parseFloat(elDiscount.replaceAll(",", "")),
            designer: elDesigner === EmptyString ? 0 : parseFloat(elDesigner.replaceAll(",", "")),
            drafter: elDrafter === EmptyString ? 0 : parseFloat(elDrafter.replaceAll(",", "")),
            tax: elTax === EmptyString ? 0 : parseFloat(elTax.replaceAll(",", "")),
            profit: elProfit === EmptyString ? 0 : parseFloat(elProfit.replaceAll(",", ""))
        }
        let projectElectronic = {
            electronicSellingPrice: electronicSalesPrice === EmptyString ? 0 : parseFloat(electronicSalesPrice.replaceAll(",", "")),
            buyingPrice: electronicHpp === EmptyString ? 0 : parseFloat(electronicHpp.replaceAll(",", "")),
            internalMarketing: electronicInMarketing === EmptyString ? 0 : parseFloat(electronicInMarketing.replaceAll(",", "")),
            discount: electronicDiscount === EmptyString ? 0 : parseFloat(electronicDiscount.replaceAll(",", "")),
            designer: electronicDesigner === EmptyString ? 0 : parseFloat(electronicDesigner.replaceAll(",", "")),
            other: electronicOthers === EmptyString ? 0 : parseFloat(electronicOthers.replaceAll(",", "")),
            profit: electronicProfit === EmptyString ? 0 : parseFloat(electronicProfit.replaceAll(",", ""))
        }
        let projectAccessories = {
            accesorisSellingPrice: accSalesPrice === EmptyString ? 0 : parseFloat(accSalesPrice.replaceAll(",", "")),
            hpp: accHpp === EmptyString ? 0 : parseFloat(accHpp.replaceAll(",", "")),
            externalMarketing: accOutMarketing === EmptyString ? 0 : parseFloat(accOutMarketing.replaceAll(",", "")), 
            internalMarketing: accInMarketing === EmptyString ? 0 : parseFloat(accInMarketing.replaceAll(",", "")),
            discount: accDiscount === EmptyString ? 0 : parseFloat(accDiscount.replaceAll(",", "")),
            designer: accDesigner === EmptyString ? 0 : parseFloat(accDesigner.replaceAll(",", "")),
            drafter: accDrafter === EmptyString ? 0 : parseFloat(accDrafter.replaceAll(",", "")),
            other: accOthers === EmptyString ? 0 : parseFloat(accOthers.replaceAll(",", "")),
            profit: accProfit === EmptyString ? 0 : parseFloat(accProfit.replaceAll(",", ""))
        }

        await createProject({
            data: {
                projectLocation: projectLocation,
                clientName: clientName,
                marketingName: marketingName,
                subConName: subConName,
                comfee: comfee === EmptyString ? 0 : parseFloat(comfee.replaceAll(",", "")),
                companyId: localStorage.getItem("CompanyId"),
                termin1: termin1 === EmptyString ? 0 : parseFloat(termin1.replaceAll(",", "")),
                termin2: termin2 === EmptyString ? 0 : parseFloat(termin2.replaceAll(",", "")),
                termin3: termin3 === EmptyString ? 0 : parseFloat(termin3.replaceAll(",", "")),
                termin4: termin4 === EmptyString ? 0 : parseFloat(termin4.replaceAll(",", "")),
                termin5: termin5 === EmptyString ? 0 : parseFloat(termin5.replaceAll(",", "")),
                terminSubCon1: terminSubCon1 === EmptyString ? 0 : parseFloat(terminSubCon1.replaceAll(",", "")),
                terminSubCon2: terminSubCon2 === EmptyString ? 0 : parseFloat(terminSubCon2.replaceAll(",", "")),
                terminSubCon3: terminSubCon3 === EmptyString ? 0 : parseFloat(terminSubCon3.replaceAll(",", "")),
                terminSubCon4: terminSubCon4 === EmptyString ? 0 : parseFloat(terminSubCon4.replaceAll(",", "")),
                terminSubCon5: terminSubCon5 === EmptyString ? 0 : parseFloat(terminSubCon5.replaceAll(",", "")),
                projectFurniture: projectFurniture,
                projectSipil: projectSipil,
                projectElectrical: projectElectrical,
                projectElectronic: projectElectronic,
                projectAccessories: projectAccessories
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company/project") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetProjectById(paramProjectId){
        await getProjectById({
            data: {
                projectId: parseInt(paramProjectId)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setClientName(data.project.clientName)
                setMarketingName(data.project.marketingName)
                setProjectLocation(data.project.projectLocation)
                setSubConName(data.project.subConName)
                setComfee(money(String(data.project.comfee)))
                setTermin1(money(String(data.project.termin1)))
                setTermin2(money(String(data.project.termin2)))
                setTermin3(money(String(data.project.termin3)))
                setTermin4(money(String(data.project.termin4)))
                setTermin5(money(String(data.project.termin5)))

                setTerminSubCon1(money(String(data.project.terminSubCon1)))
                setTerminSubCon2(money(String(data.project.terminSubCon2)))
                setTerminSubCon3(money(String(data.project.terminSubCon3)))
                setTerminSubCon4(money(String(data.project.terminSubCon4)))
                setTerminSubCon5(money(String(data.project.terminSubCon5)))

                setFurSalesPrice(money(String(data.projectFurniture.furnitureSellingPrice)))
                setFurHpp(money(String(data.projectFurniture.hppDhowi)))
                setFurOperational(money(String(data.projectFurniture.workerOperational)))
                setFurInsurance(money(String(data.projectFurniture.insurance)))
                setFurMarketingCommission(money(String(data.projectFurniture.marketingCommission)))
                setFurDesigner(money(String(data.projectFurniture.designer)))
                setFurDrafter(money(String(data.projectFurniture.drafter)))
                setFurTax(money(String(data.projectFurniture.tax)))
                setFurProfit(money(String(data.projectFurniture.profit)))

                setCivSalesPrice(money(String(data.projectCivil.civilSellingPrice)))
                setCivHpp(money(String(data.projectCivil.hppDhowi)))
                setCivOutMarketing(money(String(data.projectCivil.externalMarketing)))
                setCivInMarketing(money(String(data.projectCivil.internalMarketing)))
                setCivInsurance(money(String(data.projectCivil.insurance)))
                setCivMarketingCommission(money(String(data.projectCivil.marketingCommission)))
                setCivDiscount(money(String(data.projectCivil.discount)))
                setCivDesigner(money(String(data.projectCivil.designer)))
                setCivDrafter(money(String(data.projectCivil.drafter)))
                setCivTax(money(String(data.projectCivil.tax)))
                setCivProfit(money(String(data.projectCivil.profit)))
                
                setElSalesPrice(money(String(data.projectElectrical.electricalSellingPrice)))
                setElHpp(money(String(data.projectElectrical.hppDhowi)))
                setElOutMarketing(money(String(data.projectElectrical.externalMarketing)))
                setElInMarketing(money(String(data.projectElectrical.internalMarketing)))
                setElDiscount(money(String(data.projectElectrical.discount)))
                setElDesigner(money(String(data.projectElectrical.designer)))
                setElDrafter(money(String(data.projectElectrical.drafter)))
                setElTax(money(String(data.projectElectrical.tax)))
                setElProfit(money(String(data.projectElectrical.profit)))

                setElectronicSalesPrice(money(String(data.projectElectronic.electronicSellingPrice)))
                setElectronicHpp(money(String(data.projectElectronic.buyingPrice)))
                setElectronicInMarketing(money(String(data.projectElectronic.internalMarketing)))
                setElectronicDiscount(money(String(data.projectElectronic.discount)))
                setElectronicDesigner(money(String(data.projectElectronic.designer)))
                setElectronicOthers(money(String(data.projectElectronic.other)))
                setElectronicProfit(money(String(data.projectElectronic.profit)))
                
                setAccSalesPrice(money(String(data.projectAccessories.accessoriesSellingPrice)))
                setAccHpp(money(String(data.projectAccessories.hpp)))
                setAccOutMarketing(money(String(data.projectAccessories.externalMarketing)))
                setAccInMarketing(money(String(data.projectAccessories.internalMarketing)))
                setAccDiscount(money(String(data.projectAccessories.discount)))
                setAccDesigner(money(String(data.projectAccessories.designer)))
                setAccDrafter(money(String(data.projectAccessories.drafter)))
                setAccOthers(money(String(data.projectAccessories.other)))
                setAccProfit(money(String(data.projectAccessories.profit)))

                setStatusCode(data.project.status)
                setStatus(data.project.status)
                setCreateDate(data.project.createdDate)
                setUpdateDate(data.project.updatedDate)
                setUpdateBy(data.project.updatedBy)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateProject(paramProjectId){ 
        let projectFurniture = {
            furnitureSellingPrice: furSalesPrice === EmptyString ? 0 : parseFloat(furSalesPrice.replaceAll(",", "")),
            hppDhowi: furHpp === EmptyString ? 0 : parseFloat(furHpp.replaceAll(",", "")),
            workerOperational: furOperational === EmptyString ? 0 : parseFloat(furOperational.replaceAll(",", "")),
            insurance: furInsurance === EmptyString ? 0 : parseFloat(furInsurance.replaceAll(",", "")),
            marketingCommission: furMarketingCommission === EmptyString ? 0 : parseFloat(furMarketingCommission.replaceAll(",", "")),
            designer: furDesigner === EmptyString ? 0 : parseFloat(furDesigner.replaceAll(",", "")),
            drafter: furDrafter === EmptyString ? 0 : parseFloat(furDrafter.replaceAll(",", "")),
            tax: furTax === EmptyString ? 0 : parseFloat(furTax.replaceAll(",", "")),
            profit: furProfit === EmptyString ? 0 : parseFloat(furProfit.replaceAll(",", ""))
        }
        let projectSipil = {
            civilSellingPrice: civSalesPrice === EmptyString ? 0 : parseFloat(civSalesPrice.replaceAll(",", "")),
            hppDhowi: civHpp === EmptyString ? 0 : parseFloat(civHpp.replaceAll(",", "")),
            externalMarketing: civOutMarketing === EmptyString ? 0 : parseFloat(civOutMarketing.replaceAll(",", "")),
            internalMarketing: civInMarketing === EmptyString ? 0 : parseFloat(civInMarketing.replaceAll(",", "")),
            discount: civDiscount === EmptyString ? 0 : parseFloat(civDiscount.replaceAll(",", "")),
            insurance: civInsurance === EmptyString ? 0 : parseFloat(civInsurance.replaceAll(",", "")),
            marketingCommission: civMarketingCommission === EmptyString ? 0 : parseFloat(civMarketingCommission.replaceAll(",", "")),
            designer: civDesigner === EmptyString ? 0 : parseFloat(civDesigner.replaceAll(",", "")),
            drafter: civDrafter === EmptyString ? 0 : parseFloat(civDrafter.replaceAll(",", "")),
            tax: civTax === EmptyString ? 0 : parseFloat(civTax.replaceAll(",", "")),
            profit: civProfit === EmptyString ? 0 : parseFloat(civProfit.replaceAll(",", ""))
        }
        let projectElectrical = {
            electricalSellingPrice: elSalesPrice === EmptyString ? 0 : parseFloat(elSalesPrice.replaceAll(",", "")),
            hppDhowi: elHpp === EmptyString ? 0 : parseFloat(elHpp.replaceAll(",", "")),
            externalMarketing: elOutMarketing === EmptyString ? 0 : parseFloat(elOutMarketing.replaceAll(",", "")),
            internalMarketing: elInMarketing === EmptyString ? 0 : parseFloat(elInMarketing.replaceAll(",", "")),
            discount: elDiscount === EmptyString ? 0 : parseFloat(elDiscount.replaceAll(",", "")),
            designer: elDesigner === EmptyString ? 0 : parseFloat(elDesigner.replaceAll(",", "")),
            drafter: elDrafter === EmptyString ? 0 : parseFloat(elDrafter.replaceAll(",", "")),
            tax: elTax === EmptyString ? 0 : parseFloat(elTax.replaceAll(",", "")),
            profit: elProfit === EmptyString ? 0 : parseFloat(elProfit.replaceAll(",", ""))
        }
        let projectElectronic = {
            electronicSellingPrice: electronicSalesPrice === EmptyString ? 0 : parseFloat(electronicSalesPrice.replaceAll(",", "")),
            buyingPrice: electronicHpp === EmptyString ? 0 : parseFloat(electronicHpp.replaceAll(",", "")),
            internalMarketing: electronicInMarketing === EmptyString ? 0 : parseFloat(electronicInMarketing.replaceAll(",", "")),
            discount: electronicDiscount === EmptyString ? 0 : parseFloat(electronicDiscount.replaceAll(",", "")),
            designer: electronicDesigner === EmptyString ? 0 : parseFloat(electronicDesigner.replaceAll(",", "")),
            other: electronicOthers === EmptyString ? 0 : parseFloat(electronicOthers.replaceAll(",", "")),
            profit: electronicProfit === EmptyString ? 0 : parseFloat(electronicProfit.replaceAll(",", ""))
        }
        let projectAccessories = {
            accesorisSellingPrice: accSalesPrice === EmptyString ? 0 : parseFloat(accSalesPrice.replaceAll(",", "")),
            hpp: accHpp === EmptyString ? 0 : parseFloat(accHpp.replaceAll(",", "")),
            externalMarketing: accOutMarketing === EmptyString ? 0 : parseFloat(accOutMarketing.replaceAll(",", "")), 
            internalMarketing: accInMarketing === EmptyString ? 0 : parseFloat(accInMarketing.replaceAll(",", "")),
            discount: accDiscount === EmptyString ? 0 : parseFloat(accDiscount.replaceAll(",", "")),
            designer: accDesigner === EmptyString ? 0 : parseFloat(accDesigner.replaceAll(",", "")),
            drafter: accDrafter === EmptyString ? 0 : parseFloat(accDrafter.replaceAll(",", "")),
            other: accOthers === EmptyString ? 0 : parseFloat(accOthers.replaceAll(",", "")),
            profit: accProfit === EmptyString ? 0 : parseFloat(accProfit.replaceAll(",", ""))
        }

        await updateProject({
            data: {
                projectId: paramProjectId,
                projectLocation: projectLocation,
                clientName: clientName,
                marketingName: marketingName,
                subConName: subConName,
                comfee: parseFloat(comfee.replaceAll(",", "")),
                companyId: localStorage.getItem("CompanyId"),
                termin1: termin1 === EmptyString ? 0 : parseFloat(termin1.replaceAll(",", "")),
                termin2: termin2 === EmptyString ? 0 : parseFloat(termin2.replaceAll(",", "")),
                termin3: termin3 === EmptyString ? 0 : parseFloat(termin3.replaceAll(",", "")),
                termin4: termin4 === EmptyString ? 0 : parseFloat(termin4.replaceAll(",", "")),
                termin5: termin5 === EmptyString ? 0 : parseFloat(termin5.replaceAll(",", "")),
                terminSubCon1: terminSubCon1 === EmptyString ? 0 : parseFloat(terminSubCon1.replaceAll(",", "")),
                terminSubCon2: terminSubCon2 === EmptyString ? 0 : parseFloat(terminSubCon2.replaceAll(",", "")),
                terminSubCon3: terminSubCon3 === EmptyString ? 0 : parseFloat(terminSubCon3.replaceAll(",", "")),
                terminSubCon4: terminSubCon4 === EmptyString ? 0 : parseFloat(terminSubCon4.replaceAll(",", "")),
                terminSubCon5: terminSubCon5 === EmptyString ? 0 : parseFloat(terminSubCon5.replaceAll(",", "")),
                terminSubCon5: terminSubCon5 === EmptyString ? 0 : parseFloat(terminSubCon5.replaceAll(",", "")),
                projectFurniture: projectFurniture,
                projectSipil: projectSipil,
                projectElectrical: projectElectrical,
                projectElectronic: projectElectronic,
                projectAccessories: projectAccessories
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/company/project") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteProject(paramProjectId, paramStatus){
        await deleteProject({
            data: {
                projectId: paramProjectId,
                status: paramStatus
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/company/project")
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
        
        await checkAccess({
            data: {
                userId: userId, 
                menuId: menuId,
                companyId: companyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                access = response.data
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
        
        return access
    }

    // Function
    function fFormValidation(){
        let errorCount = 0
        
        if (clientName === null || clientName === EmptyString){
            errorCount++
            setErrClientName(true)
        }else{
            setErrClientName(false)
        }
        
        if (marketingName === null || marketingName === EmptyString){
            errorCount++
            setErrMarketingName(true)
        }else{
            setErrMarketingName(false)
        }

        if (projectLocation === null || projectLocation === EmptyString){
            errorCount++
            setErrProjectLocation(true)
        }else{
            setErrProjectLocation(false)
        }

        if (subConName === null || subConName === EmptyString){
            errorCount++
            setErrSubConName(true)
        }else{
            setErrSubConName(false)
        }

        if (comfee === null || comfee === EmptyString){
            errorCount++
            setErrComfee(true)
        }else{
            setErrComfee(false)
        }
        
        if (errTermin){
            errorCount++
        }

        if (errTerminSubCon){
            errorCount++
        }

        if(errorCount > 0){
            return false
        }else{
            return true
        }
    }
    
    return(
        <div className="flex flex-col gap-2">
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Project Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Client Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Client</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={clientName} onChange={clientNameChange} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errClientName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Client Name is required!</span>
                    </div>
                </div>

                {/* Marketing */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Marketing</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={marketingName} onChange={marketingNameChange} maxLength={30} disabled={formType === FormTypeEdit ? true : false} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errMarketingName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Marketing is required!</span>
                    </div>
                </div>

                {/* Project Location */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Project Location</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={projectLocation} onChange={projectLocationChange} maxLength={100} />
                        </div>
                    </div>
                    <div className={`flex items-center ${errProjectLocation ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Project Location is required!</span>
                    </div>
                </div>

                {/* Contractor Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Sub Contractor</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        {/* <div className="w-full sm:w-72">
                            <input className="input" value={subConName} onChange={subConNameChange} disabled={formType === FormTypeEdit ? true : false} />
                        </div> */}
                        <div className="w-full sm:w-72">
                            <Dropdown className={`${formType === FormTypeAdd ? '' : 'hidden'}`} options={subConOptions} value={subConName} onChange={subConNameChange} />
                            <input className={`input ${formType === FormTypeAdd ? 'hidden' : ''}`} value={subConName} disabled={true} />
                        </div>
                    </div>
                     
                    <div className={`flex items-center ${errSubConName ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Sub Contractor Name is required!</span>
                    </div>
                </div>

                {/* Comfee */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Comfee</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={comfee} onChange={comfeeChange} disabled={formType === FormTypeEdit ? true : false} onKeyUp={checkTotalTermin}/>
                        </div>
                    </div>
                    <div className={`flex items-center ${errComfee ? 'block' : 'hidden'}`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Comfee is required!</span>
                    </div>
                </div>

                {/* Payment Plan */}
                <div className="mt-5">
                    <div className="flex flex-col">
                        <div className="w-full">
                            <span className="font-semibold text-xl">Client Payment Plan</span>
                            <hr />
                        </div>
                    </div>
                    <div className={`flex ${errTermin ? 'block' : 'hidden'}`}>
                        <span className="text-red-500">{errTerminMessage}</span>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 1</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={termin1} onChange={termin1Change} placeholder="T1" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 2</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={termin2} onChange={termin2Change} placeholder="T2" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 3</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={termin3} onChange={termin3Change} placeholder="T3" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 4</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={termin4} onChange={termin4Change} placeholder="T4" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 5</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={termin5} onChange={termin5Change} placeholder="T5" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                
                {/* SubCon Plan */}
                <div className="mt-5">
                    <div className="w-full">
                        <span className="font-semibold text-xl">Sub Contractor Payment Plan</span>
                        <hr />
                    </div>
                    <div className={`flex ${errTerminSubCon ? 'block' : 'hidden'}`}>
                        <span className="text-red-500">{errTerminSubConMessage}</span>
                    </div>
                </div>

                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 1</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={terminSubCon1} onChange={terminSubCon1Change} placeholder="T1" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 2</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={terminSubCon2} onChange={terminSubCon2Change} placeholder="T2" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 3</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={terminSubCon3} onChange={terminSubCon3Change} placeholder="T3" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 4</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={terminSubCon4} onChange={terminSubCon4Change} placeholder="T4" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Termin 5</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={terminSubCon5} onChange={terminSubCon5Change} placeholder="T5" onKeyUp={checkTotalTermin} />
                        </div>
                    </div>
                </div>

                {/* Furniture */}
                <div className="p-4 border rounded bg-white mt-4">
                    <div className="cursor-pointer" onClick={furnitureClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Furniture</span>
                            <ChevronRightIcon className={`w-8 ${showFurniture ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showFurniture ? 'block' : 'hidden'}`} />
                        </div>
                        
                        <hr className={`${showFurniture ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showFurniture ? 'block' : 'hidden'}`}>
                        {/* Furniture Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Harga Jual (Nilai tanpa comfee)</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furSalesPrice} onChange={furSalesPriceChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furHpp} onChange={furHppChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Operational */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Operational Tukang</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furOperational} onChange={furOperationalChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Insurance */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Insurance</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furInsurance} onChange={furInsuranceChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Marketing Commission */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Marketing Commission</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furMarketingCommission} onChange={furMarketingCommissionChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furDesigner} onChange={furDesignerChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furDrafter} onChange={furDrafterChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furTax} onChange={furTaxChange} onKeyUp={calculateFurnitureProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Furniture Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-56">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={furProfit} onChange={furProfitChange} disabled={true} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-56" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                    </div>
                </div>
                
                {/* Civil & Electrical */}
                <div className="p-4 border rounded bg-white mt-4">
                    <div className="cursor-pointer" onClick={civilClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Civil & Electrical</span>
                            <ChevronRightIcon className={`w-8 ${showCivil ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showCivil ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showCivil ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showCivil ? 'block' : 'hidden'}`}>
                        {/* Civil Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civSalesPrice} onChange={civSalesPriceChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civHpp} onChange={civHppChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Out Marketing */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civOutMarketing} onChange={civOutMarketingChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil In Marketing */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civInMarketing} onChange={civInMarketingChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Discount */}
                        <div className="hidden">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civDiscount} onChange={civDiscountChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Insurance */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Insurance</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civInsurance} onChange={civInsuranceChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Marketing Commission */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Commission</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civMarketingCommission} onChange={civMarketingCommissionChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civDesigner} onChange={civDesignerChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civDrafter} onChange={civDrafterChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civTax} onChange={civTaxChange} onKeyUp={calculateCivilProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Civil Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={civProfit} onChange={civProfitChange} disabled={true} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Electrical */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={electricalClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Electrical</span>
                            <ChevronRightIcon className={`w-8 ${showElectrical ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showElectrical ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showElectrical ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showElectrical ? 'block' : 'hidden'}`}>
                        {/* Electrical Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elSalesPrice} onChange={elSalesPriceChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elHpp} onChange={elHppChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Out Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elOutMarketing} onChange={elOutMarketingChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elInMarketing} onChange={elInMarketingChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elDiscount} onChange={elDiscountChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elDesigner} onChange={elDesignerChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elDrafter} onChange={elDrafterChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Tax */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Tax</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elTax} onChange={elTaxChange} onKeyUp={calculateElectricalProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electrical Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={elProfit} onChange={elProfitChange} disabled={true} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Electronics */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={electronicClick}>
                    <div className="flex justify-between">
                            <span className="font-semibold text-xl">Electronics</span>
                            <ChevronRightIcon className={`w-8 ${showElectronic ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showElectronic ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showElectronic ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showElectronic ? 'block' : 'hidden'}`}>
                        {/* Electronics Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicSalesPrice} onChange={electronicSalesPriceChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicHpp} onChange={electronicHppChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicInMarketing} onChange={electronicInMarketingChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicDiscount} onChange={electronicDiscountChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicDesigner} onChange={electronicDesignerChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics Others */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Lain - lain</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicOthers} onChange={electronicOthersChange} onKeyUp={calculateElectronicProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Electronics Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={electronicProfit} onChange={electronicProfitChange} disabled={true} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Accessories */}
                <div className="p-4 border rounded bg-white mt-4 hidden">
                    <div className="cursor-pointer" onClick={accessoriesClick}>
                        <div className="flex justify-between">
                            <span className="font-semibold text-xl">Accessories</span>
                            <ChevronRightIcon className={`w-8 ${showAccessories ? 'hidden' : 'block'}`} />
                            <ChevronDownIcon className={`w-8 ${showAccessories ? 'block' : 'hidden'}`} />
                        </div>
                        <hr className={`${showAccessories ? 'block' : 'hidden'}`} />
                    </div>
                    
                    <div className={`flex flex-col gap-4 mt-4 ${showAccessories ? 'block' : 'hidden'}`}>
                        {/* Accessories Harga Jual */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Harga Jual</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accSalesPrice} onChange={accSalesPriceChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories HPP */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>HPP</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accHpp} onChange={accHppChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Luar</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accOutMarketing} onChange={accOutMarketingChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories In Marketing */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Marketing Dalam</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accInMarketing} onChange={accInMarketingChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories Discount */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Discount</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accDiscount} onChange={accDiscountChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories Designer */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Designer</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accDesigner} onChange={accDesignerChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories Drafter */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Drafter</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accDrafter} onChange={accDrafterChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories Others */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Lain - lain</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accOthers} onChange={accOthersChange} onKeyUp={calculateAccessoriesProfit} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>

                        {/* Accessories Profit */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Profit</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={accProfit} onChange={accProfitChange} disabled={true} />
                                </div>
                            </div>
                            <div className={`flex items-center ${errNpwp ? 'block' : 'hidden'}`}>
                                <div className="w-48" />
                                <div className="w-9" />
                                <span className="text-red-500">NPWP is required!</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Summary */}
                <div className="mt-4">
                    <div>
                        <span className="font-semibold text-xl">Summary</span>
                        <hr />
                    </div>

                    <div className="mt-4">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 border">
                            <thead className=" text-gray-700 uppercase bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Sales
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Profit
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        Margin
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="bg-white border-b border-gray-200">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Furniture
                                    </th>
                                    <td className="px-6 py-4">
                                        {furSalesPrice === EmptyString ? "0" : furSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {furProfit === EmptyString ? "0" : furProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginFurniture()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b border-gray-200">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Civil & Electrical
                                    </th>
                                    <td className="px-6 py-4">
                                        {civSalesPrice === EmptyString ? "0" : civSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {civProfit === EmptyString ? "0" : civProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginCivil()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b hidden">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Electrical
                                    </th>
                                    <td className="px-6 py-4">
                                        {elSalesPrice === EmptyString ? "0" : elSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {elProfit === EmptyString ? "0" : elProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {furProfit === EmptyString ? "0" : furProfit}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b hidden">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Electronics
                                    </th>
                                    <td className="px-6 py-4">
                                        {electronicSalesPrice === EmptyString ? "0" : electronicSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {electronicProfit === EmptyString ? "0" : electronicProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginElectronics()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b hidden">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Accessories
                                    </th>
                                    <td className="px-6 py-4">
                                        {accSalesPrice === EmptyString ? "0" : accSalesPrice}
                                    </td>
                                    <td className="px-6 py-4">
                                        {accProfit === EmptyString ? "0" : accProfit}
                                    </td>
                                    <td className="px-6 py-4">
                                        {RoundTwoDecimals(calculateMarginAccessories()) + " %"}
                                    </td>
                                </tr>
                                <tr className="bg-white border-b">
                                    <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        Total
                                    </th>
                                    <td className="px-6 py-4">
                                        {money(calculateTotalSales())}
                                    </td>
                                    <td className="px-6 py-4">
                                        {money(calculateTotalProfit())}
                                    </td>
                                    <td className="px-6 py-4">
                                        
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />                
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? (allowDelete ? true : false) : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? (allowUndelete ? true : false) : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}